import classes from "./transaction-history-container.module.css";

const RenderFilterLabels = props => {
  const { item } = props;
  return (
    <div className={classes.tabLabel}>
      {item.label}
      <span>({item.count})</span>
    </div>
  );
};

export default RenderFilterLabels;
